import {
    displayDynamicShippingAlert
} from './_displayDynamicShippingAlert';

export const checkExpDateIsNullOrEmpty = (month, year, messageIfNullOrEmpty) => {
    if (month === null || month.length === 0 || year === null || year.length === 0) {
        //displayDynamicShippingAlert(messageIfNullOrEmpty, 'danger');
        try {
            if (month === null || month.length === 0){
                $('#generic-error-message').remove();
                $('#expirationDateGroup').removeClass('has-month-error');
                $('.form-group.card-expire-month').removeClass('has-error').find('#card-expire-month-error-message').remove();
                $('#expirationDateGroup .card-expire-month').addClass('has-error').append('<p class="help-block txt-error" id="card-expire-month-error-message">Enter Month</p>');
                $('#expirationDateGroup').addClass('has-month-error');
                $('#card-expire-month').on('change', function () {
                    $('#expirationDateGroup').removeClass('has-month-error');
                    $(this).parents('.form-group').removeClass('has-error').find('#card-expire-month-error-message').remove();
                });
            } 
            if (year === null || year.length === 0){
                $('#generic-error-message').remove();
                $('#expirationDateGroup').removeClass('has-year-error');
                $('.form-group.card-expire-year').removeClass('has-error').find('#card-expire-year-error-message').remove();
                $('#expirationDateGroup .card-expire-year').addClass('has-error').append('<p class="help-block txt-error" id="card-expire-year-error-message">Enter Year</p>');
                $('#expirationDateGroup').addClass('has-year-error');
                $('#card-expire-year').on('change', function () {
                    $('#expirationDateGroup').removeClass('has-year-error');
                    $(this).parents('.form-group').removeClass('has-error').find('#card-expire-year-error-message').remove();
                });
            }
            if (month === null || month.length === 0 ){
                $('#card-expire-month').focus();
            } else if (year === null || year.length === 0){
                $('#card-expire-year').focus();
            }
//            console.log(document.activeElement);
        }
        catch (err) {
            //document.getElementById("messages").innerHTML = err.message;
            $('#messages').append('<div data-twist="generic-error" id="generic-error-message" class="alert alert-danger" role="alert" aria-live="assertive"><div class="generic-error-display-message">A generic error has occurred.</div></div>');
        }
        return true;
    }
    return false;
};
